/*
 * export event types
 */
export const ON_KEX_ERROR = '2';
export const ON_FIXED_CIRCLE_LOADING = '3';
//Minicart events
export const ON_OPEN_MINICART = '9';
//Search events
export const TOGGLE_SEARCH_MODAL = '10.3';
//Theme
export const SET_THEME = '11';

type EventsType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export const EventDispatcher = (function () {
  const events: EventsType = {};
  /**
   * Dispatches an event if it exists
   * Example usage: EventDispatcher.dispatch('namechanged', { name: 'John' });
   * @param {*} event to dispatch
   * @param {*} data to send with the event
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch = (event: any, ...data: any) => {
    if (!events[event]) return; // no one is listening to this event
    for (let i = 0; i < events[event].length; i += 1) {
      events[event][i](...data);
    }
  };

  /**
   * Subscribes to an event
   * Example usage: EventDispatcher.subscribe('namechanged', function(data) { alert(data.name); });
   * @param {*} event to subscribe to
   * @param {*} callback to call on dispatch
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const subscribe = (event: any, callback: any) => {
    if (!events[event]) events[event] = []; // new event
    events[event] = [...events[event], callback];
  };

  /**
   * Unsubscribes a function to an event.
   * @param {*} event to unsubscribe to
   * @param {*} callback to remove from event
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const unsubscribe = (event: any, callback: any) => {
    if (events[event] && events[event].length === 1) {
      delete events[event];
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      events[event] = events[event].filter((fn: any) => fn !== callback);
    }
  };

  return {
    dispatch,
    subscribe,
    unsubscribe,
  };
})();
